window.addEventListener('load', function() {
    if (this.document.querySelector('.start_calendar')) {
        var second = 1000, minute = second * 60, hour = minute * 60, date = hour * 24;
        let endYear = document.querySelector('.event_year').dataset.value;
        let endMonth = document.querySelector('.event_month').dataset.value;
        let endDate = document.querySelector('.event_date').dataset.value;
        let endHour = document.querySelector('.event-end-hour').dataset.value;
        let hoursPerDay = 24;

        let startYear = document.querySelector('.event_year').dataset.startValue;
        let startMonth = document.querySelector('.event_month').dataset.startValue;
        let startDate = document.querySelector('.event_date').dataset.startValue;
        let startHour = document.querySelector('.event-end-hour').dataset.startValue;
        
        let countDown = new Date(endYear, endMonth, endDate, endHour).getTime();
        let startDown = new Date(startYear, startMonth, startDate, startHour).getTime();

        // Define your PST date components
        let x = this.setInterval(function() {
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleString("en-US", { timeZone: "PST" });
            const nowtime = new Date(formattedDate).getTime();

            let startTimer = startDown - nowtime;
            if (startTimer < 0) {
                document.querySelector('.custom-timer-wrapper').classList.remove('hidden');
                var distance = countDown - nowtime;
                if (distance > 0) {
                    let totalDays = Math.floor(distance / date);

                    document.querySelectorAll('.hc_cd_timernum').forEach(item => {
                        item.classList.remove('hidden');
                    });
                    document.querySelectorAll('.timer_loading').forEach(item => {
                        item.classList.add('hidden');
                    });

                    if (totalDays > 0) {
                        updateRemainingTime();
                    } else {
                        // Calculate the remaining time for today
                        const remainingHours = Math.floor(distance / hour);
                        const remainingMinutes = Math.floor((distance % hour) / minute);
                        const remainingSeconds = Math.floor((distance % minute) / second);

                        document.querySelectorAll('.js-timer-hours').forEach(hourItem => {
                            hourItem.innerText = remainingHours;
                        });
                        document.querySelectorAll('.js-timer-minutes').forEach(minuteItem => {
                            minuteItem.innerText = remainingMinutes;
                        });
                        document.querySelectorAll('.js-timer-seconds').forEach(secondItem => {
                            secondItem.innerText = remainingSeconds;
                        });
                    }
                } else {
                    document.querySelector('.custom-timer-wrapper').classList.add('hidden');
                    clearInterval(x); // Stop the interval when the countdown ends
                }
            }
        }, second);

        // Function to update the remaining time for today
        function updateRemainingTime() {
            // Get the current time in PST
            const now = new Date().toLocaleString("en-US", { timeZone: "PST" });
            const nowDate = new Date(now);

            // Set the end of the day at 11:59:59.999 PM
            const endOfDay = new Date(nowDate);
            endOfDay.setHours(23, 59, 59, 999); // Set to 11:59:59.999 PM

            // Calculate the remaining time in milliseconds
            const remainingTime = endOfDay - nowDate;

            // If the remaining time is valid (not negative)
            if (remainingTime > 0) {
                const hours = Math.floor(remainingTime / hour);
                const minutes = Math.floor((remainingTime % hour) / minute);
                const seconds = Math.floor((remainingTime % minute) / second);

                document.querySelectorAll('.js-timer-hours').forEach(hourItem => {
                    hourItem.innerText = hours;
                });
                document.querySelectorAll('.js-timer-minutes').forEach(minuteItem => {
                    minuteItem.innerText = minutes;
                });
                document.querySelectorAll('.js-timer-seconds').forEach(secondItem => {
                    secondItem.innerText = seconds;
                });
            }
        }
    }
});
